import permission from "@/middlewares/permission";


function loadView( view ) {
    return () => import(`@/views/admin/candidates/${ view }.vue`);
}


const DetailedResults = loadView( 'DetailedResults' );
const Index = loadView( 'Index' );
const View = loadView('View');

const candidateRoutes = [
    {
        path: 'candidates/:id/detailed-results/:appId',
        name: 'api.candidate.profile.detailedResults',
        component: DetailedResults,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'candidates',
        name: 'api.candidate.getList',
        component: Index,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'candidates/:id',
        name: 'api.candidate.get',
        component: View,
        meta: {
            middleware: permission
        }
    }
];

export default candidateRoutes;
